// extracted by mini-css-extract-plugin
export default {"Gallery":"Gallery_Gallery__cqkHZ","Images":"Gallery_Images__Y1eWQ"};